import { useEffect, useRef } from 'react'

export function useInterval(callback, delay, enabled = true) {
  const savedCallback = useRef()

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    if (!enabled || delay == null) return

    const tick = () => savedCallback.current?.()
    const id = setInterval(tick, delay)

    return () => clearInterval(id)
  }, [delay, enabled])
}
